import { css } from '@linaria/atomic';

const locationChipChipSingleChipStyle1 = css`
  width: auto;
  max-width: none;
`;

export const LocationChipStyles = {
  locationChipChipSingleChipStyle1,
};
